export class ServerApiService {
    constructor(client, authIntance) {
        this.client = client;
        this.authIntance = authIntance;
    }
    get deviceHash() {
        return this.authIntance.hash;
    }
    async getEventlist(screenId = null) {
        const response = await this.client.client.get(`api/v1/devices/${this.authIntance.hash}/eventlist` + (screenId ? `?screen_id=${screenId}` : ''));
        return response.data;
    }
    async getEventlistsForAllDisplays() {
        const response = await this.client.client.get(`api/v1/devices/${this.authIntance.hash}/all-eventlists`);
        return response.data;
    }
    async updateDevice(data) {
        const resposne = await this.client.client.put(`api/v1/devices/${this.authIntance.hash}/update-by-hash`, data);
        return resposne.data;
    }
    async getDevice() {
        const response = await this.client.client.get(`api/v1/devices/${this.authIntance.hash}/get-by-hash`);
        return response.data;
    }
    async getServerTime() {
        const response = await this.client.client.get(`sync-time`);
        return response.data;
    }
    async checkForConnection() {
        try {
            const response = await this.client.client.get(`up`);
            return response?.status === 200;
        }
        catch (error) {
            return false;
        }
    }
    async getMediaLibrary() {
        const response = await this.client.client.get(`api/v1/devices/${this.authIntance.hash}/media-library`);
        return response.data;
    }
    async getMigrations() {
        const response = await this.client.client.get(`api/v1/devices/${this.authIntance.hash}/migrations`);
        return response.data;
    }
    async reportMigration(slug, status, output) {
        const response = await this.client.client.post(`api/v1/devices/${this.authIntance.hash}/migrations/${slug}/report`, {
            status,
            output,
        });
        return response.data;
    }
}
//# sourceMappingURL=ServerApiService.js.map